var _excluded = ["text", "isSmall", "size", "hasBorder", "variant", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string, bool, oneOf } from 'prop-types';
import classNames from 'classnames';
import './Puck.scss';
var propTypes = {
  text: string.isRequired,

  /** Make the puck small
   * @deprecated Please use size instead.
   * */
  isSmall: bool,

  /** Turns the border on or off. Only applicable to the round, yellow version of the puck.
   * The border should only be turned off if the Puck is used on a dark background. */
  hasBorder: bool,

  /** The normal Puck is round and yellow. However there are some rare use cases where the Puck is presented as a anthracite square/rectangle with yellow text */
  variant: oneOf(['round', 'square']),

  /** Choose the size of the Puck. */
  size: oneOf(['small', 'medium', 'large']),

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  size: 'medium',
  hasBorder: true,
  variant: 'round'
};
/**
 * The puck is used to display platform information.
 */

var Puck = function Puck(_ref) {
  var text = _ref.text,
      isSmall = _ref.isSmall,
      size = _ref.size,
      hasBorder = _ref.hasBorder,
      variant = _ref.variant,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = classNames('rds-puck', {
    'rds-puck--size-small': isSmall || size === 'small',
    'rds-puck--size-medium': size === 'medium',
    'rds-puck--size-large': size === 'large',
    'rds-puck--has-border': hasBorder === true && variant === 'round',
    'rds-puck--variant-square': variant === 'square',
    'rds-puck--extra-padding': text.length > 1,
    'rds-puck--letter-fix': text.toLowerCase() === 'c' | text.toLowerCase() === 'g'
  }, className);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: componentClassNames
  }, rest), text);
};

Puck.propTypes = propTypes;
Puck.defaultProps = defaultProps;
export default Puck;